import { toBlob } from "./file.mjs";
import { isString } from "./is.mjs";
const regexBase64 = "(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+/]{3}=)?(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}(==)?|[A-Za-z0-9+\\/]{3}=?)?";
const regexMimeBase64 = "data:(.*);base64,";
export const REGEXP_BASE_64 = new RegExp(`^${regexBase64}$`, "i");
export const REGEX_MIME_BASE_64 = new RegExp(`^(${regexMimeBase64})(${regexBase64})$`, "i");
const mimeTypeSignatures = {
  JVBERi0: "application/pdf",
  R0lGODdh: "image/gif",
  R0lGODlh: "image/gif",
  iVBORw0KGgo: "image/png",
  "/9j/": "image/jpg"
};
export const detectMimeType = (string) => {
  for (const key in mimeTypeSignatures) {
    if (string.startsWith(key)) {
      return mimeTypeSignatures[key];
    }
  }
};
export const toBase64 = async (data) => {
  const blob = isString(data) ? await toBlob(data) : data;
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};
export const isBase64 = (string) => REGEXP_BASE_64.test(string);
export const isMimeBase64 = (string) => REGEX_MIME_BASE_64.test(string);
export const withMimeBase64 = (base64) => {
  if (isMimeBase64(base64))
    return base64;
  const mimeType = detectMimeType(base64);
  return mimeType ? `data:${mimeType};base64,${base64}` : base64;
};
export const getMimeBase64 = (base64) => {
  const matches = REGEX_MIME_BASE_64.exec(base64);
  return matches ? matches[2] : void 0;
};
